import { createTypes } from 'reduxsauce'
import { IComponentState, IPaginator} from '../root.types'
import { Alert } from '../../application/models/alert/alert'

export const AlertTypes = createTypes(`

    LOAD_ALERT_SUCCESS
    LOAD_ALERT_FAILURE 
    LOAD_ALERT_REQUEST

    CREATE_ALERT_REQUEST
    CREATE_ALERT_SUCCESS
    CREATE_ALERT_FAILURE

    FIND_ALERT_SUCCESS
    FIND_ALERT_FAILURE 
    FIND_ALERT_REQUEST

    UPDATE_ALERT_REQUEST
    UPDATE_ALERT_SUCCESS
    UPDATE_ALERT_FAILURE
`,
    {
        prefix: '@alert/'
    }
)

/**
 * State type
 */
export interface IAlertState {
    readonly create: ICreateState
    readonly list: IListState
}
export interface IListState extends IComponentState {
    readonly alerts: Alert[]
    readonly paginator: IPaginator
}
export interface ICreateState extends IComponentState {
    readonly alert: Alert
}
export interface IActionLoad {
    readonly startDate: string
    readonly endDate: string
    readonly paginator?: IPaginator
}
export interface IActionFind{
    readonly alertId: string
}
export interface IActionUpdate{
     readonly alert: Alert
}
export interface IActionAlert{
    readonly date: string
    readonly paginator?: IPaginator
}